export class InstituicaoEnsino {
    public active: Boolean;
    public address: String;
    public cep: String;
    public city: String;
    public cityId: Number;
    public editableInstitutionName: String;
    public id: Number;
    public institutionCourseDuration: String;
    public institutionCourseEndYear: String;
    public institutionCourseName: String;
    public institutionCoursePeriod: String;
    public institutionCourseType: String;
    public institutionCourseYear: String;
    public institutionEnrollmentId: String;
    public institutionId: Number;
    public institutionName: String;
    public lat: Number;
    public lng: Number;
    public mecId: String;
    public name: String;
    public nameShort: String;
    public state: String;
    public stateId: Number;
    public type: String;
}